export const HS_GAIL_ACCOUNT_EMAIL_KEY = "GailHSAccountEmail";
